/* eslint-disable */
// /src/pages/FaqPage.jsx
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import BrandHeader from "../components/BrandHeader";
import { getFaqPublished } from "../services/faqConfigService";
import { useAppConfig } from "../context/AppConfigContext";

/* ===== Layout ===== */
const Wrap = styled.div`
  min-height: 100vh;
  background: linear-gradient(180deg, #D7E8FF 0%, #EAF3FF 100%);
  display: flex;
  flex-direction: column;
`;
const Sheet = styled.div`
  background: #F7FAFF;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, .05);
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
`;
const TopBar = styled.div`
  height: 52px;
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 0 12px;
  border-bottom: 1px solid #e6eefc;

  button {
    appearance: none;
    background: transparent;
    border: 0;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: #111;
    font-weight: 700;
    padding: 6px 8px;
    border-radius: 10px;
  }
  button:active {
    transform: translateY(1px);
  }
  svg {
    width: 18px;
    height: 18px;
  }
`;
const Body = styled.div`
  flex: 1;
  padding: 16px;
  display: flex;
  flex-direction: column;
  row-gap: 14px;
  max-width: 920px;
  width: 100%;
  margin: 0 auto;
`;

/* ===== Header Image ===== */
const HeaderImgWrap = styled.div`
  margin-bottom: 12px;
  text-align: center;
`;
const HeaderImg = styled.img`
  max-width: 280px;
  width: 100%;
  height: auto;
  display: block;
  margin: 0 auto;
`;

/* ===== Category / Items ===== */
const Category = styled.section`
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 1px 10px rgba(0, 0, 0, .06);
  padding: 14px 12px 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
const CatHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 6px 2px 6px;
`;
const CatTitle = styled.h2`
  margin: 0;
  font-size: 16px;
  font-weight: 900;
  color: #0f172a;
  letter-spacing: -0.2px;
`;

const Item = styled.div`
  border: 1px solid #E3EAF3;
  border-radius: 12px;
  background: #fff;
  overflow: hidden;
`;
const QRow = styled.button`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: 10px;
  padding: 14px;
  background: #F8FBFF;
  border: 0;
  text-align: left;
  cursor: pointer;
  font-weight: 900;
  color: #0f172a;
  transition: background .15s ease;

  &:hover {
    background: #F1F7FF;
  }
`;
const Chevron = styled.span`
  display: inline-grid;
  place-items: center;
  width: 24px;
  height: 24px;
  border-radius: 8px;
  color: #0f172a;
  transform: rotate(${(p) => (p.$open ? 180 : 0)}deg);
  transition: .2s ease;

  svg {
    width: 18px;
    height: 18px;
  }
`;
const APanel = styled.div`
  padding: 0 14px;
  max-height: ${(p) => (p.$open ? "320px" : "0")};
  overflow: hidden;
  transition: max-height .24s ease;
  background: #fff;
  border-top: 1px dashed #e6eefc;
`;
const Answer = styled.div`
  padding: 12px 2px 14px;
  color: #475569;
  line-height: 1.6;
  font-size: 14px;
  white-space: pre-line;
`;
const BottomPad = styled.div`
  height: max(24px, env(safe-area-inset-bottom));
`;

/* ===== Page ===== */
export default function FaqPage() {
  const nav = useNavigate();
  const { config } = useAppConfig();
  const headerImg =
    config?.detailScreens?.faqScreen?.headerImg || "";

  // sections: [{ title, items: [{ q, a }, ...] }, ...]
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(true);

  // openMap: { 'secIdx-itemIdx': true }
  const [openMap, setOpenMap] = useState({});

  const keyOf = (sIdx, iIdx) => `${sIdx}-${iIdx}`;
  const toggle = (k) => setOpenMap((p) => ({ ...p, [k]: !p[k] }));

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const data = await getFaqPublished();
        const list =
          data?.sections && Array.isArray(data.sections)
            ? data.sections
            : [];
        setSections(list);
      } catch (e) {
        console.error("[FaqPage] getFaqPublished error:", e);
        setSections([]);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <Wrap>
      <Sheet>
        {/* 필요하면 홈버튼 살리고 싶을 때 사용
        <TopBar>
          <button onClick={() => nav("/home")} aria-label="홈으로 이동">
            <svg viewBox="0 0 24 24" fill="none" stroke="#111" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M3 11.5L12 4l9 7.5" />
              <path d="M5 10.5V20a1 1 0 0 0 1 1h4v-6h4v6h4a1 1 0 0 0 1-1v-9.5" />
            </svg>
            홈으로 이동
          </button>
        </TopBar>
        */}

        <Body>
          {/* 🔹 detailScreens.faqScreen.headerImg 우선 사용, 없으면 기존 BrandHeader 유지 */}
          {headerImg ? (
            <HeaderImgWrap>
              <HeaderImg src={headerImg} alt="FAQ" />
            </HeaderImgWrap>
          ) : (
            <BrandHeader subtitle="FAQ" />
          )}

          {loading && (
            <div style={{ padding: 12, color: "#64748b", fontSize: 13 }}>
              FAQ를 불러오는 중입니다…
            </div>
          )}

          {!loading && !sections.length && (
            <div style={{ padding: 12, color: "#64748b", fontSize: 13 }}>
              등록된 FAQ가 없습니다.
            </div>
          )}

          {!loading &&
            sections.length > 0 &&
            sections.map((sec, sIdx) => {
              const items = sec.items || [];
              return (
                <Category key={sIdx}>
                  <CatHeader>
                    <CatTitle>
                      {sec.title || "제목 없는 카테고리"}
                    </CatTitle>
                  </CatHeader>

                  {items.map((it, iIdx) => {
                    const k = keyOf(sIdx, iIdx);
                    const open = !!openMap[k];
                    return (
                      <Item key={k}>
                        <QRow
                          onClick={() => toggle(k)}
                          aria-expanded={open}
                        >
                          <span>{it.q || "질문 내용 없음"}</span>
                          <Chevron $open={open} aria-hidden>
                            <svg
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <polyline points="6 9 12 15 18 9" />
                            </svg>
                          </Chevron>
                        </QRow>
                        <APanel $open={open}>
                          <Answer>
                            {it.a || "답변 내용이 없습니다."}
                          </Answer>
                        </APanel>
                      </Item>
                    );
                  })}
                </Category>
              );
            })}

          <BottomPad />
        </Body>
      </Sheet>
    </Wrap>
  );
}
